export default "__VITE_ASSET__DoPRAX99__"